/* TummyHush PDP slide-to-add test. Band PDP, mobile only.
   Arm A = the normal Add to cart button. Arm B = slide-to-add in the same spot.
   Settings: pdp_ab_enabled, pdp_ab_share (% in B), pdp_ab_until (ISO end), pdp_ab_force (QA). */
(function () {
  'use strict';
  var slider = document.querySelector('[data-th-pdp-ab]');
  if (!slider) return;
  var submitWrap = slider.closest('.thv2__submit');
  var button = submitWrap && submitWrap.querySelector('.main-product-atc');
  if (!submitWrap || !button) return;

  var share = Number(slider.dataset.share) || 0;
  var untilMs = slider.dataset.until ? Date.parse(slider.dataset.until) : NaN;
  var force = slider.dataset.force || 'none';
  var mobile = window.matchMedia('(max-width: 749px)').matches && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  var windowOpen = !(untilMs > 0) || Date.now() < untilMs;
  var active = mobile && share > 0 && windowOpen;

  var param = (location.search.match(/[?&]th_pdp_ab=([ABab])(?:&|$)/) || [])[1];
  var qa = false;
  var bucket = null;
  if (param) { bucket = param.toUpperCase(); qa = true; }
  else if (force === 'A' || force === 'B') { bucket = force; qa = true; }
  else if (active) {
    var stored = null;
    try { stored = localStorage.getItem('th_pdp_ab'); } catch (error) { /* Storage may be blocked. */ }
    bucket = stored === 'A' || stored === 'B' ? stored : (Math.random() * 100 < share ? 'B' : 'A');
    try { localStorage.setItem('th_pdp_ab', bucket); } catch (error) { /* Keep the in-memory bucket. */ }
  }
  if (!bucket) return;

  function ga(name, params) {
    if (qa) return;
    try { if (typeof gtag === 'function') gtag('event', name, params || {}); } catch (error) { /* Optional analytics. */ }
  }

  function stamp() {
    if (qa) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var attrs = (cart && cart.attributes) || {};
      if (attrs.th_pdp_ab === bucket) return;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { th_pdp_ab: bucket } })
      });
    }).catch(function () { /* Attribution only. */ });
  }

  if (!qa) {
    try { if (typeof gtag === 'function') gtag('set', 'user_properties', { pdp_ab_bucket: bucket }); } catch (error) { /* Optional analytics. */ }
    var seen = false;
    try { seen = sessionStorage.getItem('th_pdp_ab_exposed') === '1'; } catch (error) { /* Optional analytics. */ }
    if (!seen) {
      try { sessionStorage.setItem('th_pdp_ab_exposed', '1'); } catch (error) { /* Memory still guards this page. */ }
      ga('th_pdp_exposed_' + bucket);
    }
    stamp();
  }

  var added = false;
  /* PUB_SUB_EVENTS is a top-level const in pubsub.js, so it is not on window. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      ga('th_pdp_atc_' + bucket);
      stamp();
      if (bucket === 'B') finishSlide();
    });
  }

  if (bucket !== 'B') return;

  /* ---- Arm B: slide to add ---- */
  var label = slider.querySelector('[data-th-slide-label]');
  var knob = slider.querySelector('.th-slide__knob');
  var fill = slider.querySelector('.th-slide__fill');
  var hint = submitWrap.querySelector('[data-th-slide-hint]');
  var buttonLabel = button.querySelector('[data-submit-label]');

  function syncLabel() {
    var text = buttonLabel ? buttonLabel.textContent : '';
    var price = (text.match(/\$[\d.,]+/) || [])[0];
    label.textContent = 'Slide to add' + (price ? ' · ' + price : '');
    slider.setAttribute('aria-label', 'Slide to add to cart' + (price ? ', ' + price : ''));
  }
  function syncAvailability() {
    var soldOut = button.disabled || button.getAttribute('aria-disabled') === 'true' && button.dataset.unavailable === 'true';
    submitWrap.classList.toggle('th-slide-on', !soldOut);
    slider.classList.toggle('is-on', !soldOut);
  }
  syncLabel(); syncAvailability();
  if (window.MutationObserver) {
    if (buttonLabel) new MutationObserver(function () { if (!busy) syncLabel(); }).observe(buttonLabel, { childList: true, characterData: true, subtree: true });
    new MutationObserver(syncAvailability).observe(button, { attributes: true, attributeFilter: ['disabled', 'data-unavailable'] });
  }

  var dragging = false, moved = false, startX = 0, pos = 0, max = 0, taps = 0, busy = false, doneTimer = null;
  function bounds() { max = slider.clientWidth - knob.offsetWidth - 8; }
  function setPos(p) {
    pos = Math.max(0, Math.min(max, p));
    knob.style.left = (4 + pos) + 'px';
    fill.style.width = (knob.offsetWidth + 8 + pos) + 'px';
  }
  function reset() {
    busy = false; taps = 0; added = false;
    slider.classList.remove('is-done', 'is-busy', 'is-dragging');
    knob.textContent = '→';
    syncLabel();
    setPos(0);
  }
  function finishSlide() {
    if (!busy) return;
    added = true;
    slider.classList.remove('is-busy');
    slider.classList.add('is-done');
    label.textContent = 'Added to cart ✓';
    knob.textContent = '✓';
    clearTimeout(doneTimer);
    doneTimer = setTimeout(reset, 2200);
  }
  function submitAdd(how) {
    if (busy) return;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') { setPos(0); return; }
    busy = true;
    bounds(); setPos(max);
    slider.classList.remove('is-dragging');
    slider.classList.add('is-busy');
    label.textContent = 'Adding…';
    if (hint) hint.hidden = true;
    ga(how === 'slide' ? 'th_pdp_slide_complete' : 'th_pdp_fallback_add');
    var form = button.form;
    if (form && typeof form.requestSubmit === 'function') form.requestSubmit(button); else button.click();
    /* If the add fails or the cart event never arrives, hand the control back. */
    clearTimeout(doneTimer);
    doneTimer = setTimeout(function () { if (!added) reset(); }, 8000);
  }
  function clientX(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
  function down(e) {
    if (busy) return;
    bounds(); dragging = true; moved = false;
    startX = clientX(e) - pos;
    slider.classList.add('is-dragging');
  }
  function move(e) {
    if (!dragging || busy) return;
    var x = clientX(e) - startX;
    if (Math.abs(x - pos) > 3) {
      if (!moved) { moved = true; ga('th_pdp_slide_start'); }
      setPos(x);
      if (e.cancelable) e.preventDefault();
    }
  }
  function up() {
    if (!dragging || busy) return;
    dragging = false;
    slider.classList.remove('is-dragging');
    if (!moved) {
      taps += 1;
      if (taps >= 2) { submitAdd('tap'); return; }
      slider.classList.add('is-nudge');
      setTimeout(function () { slider.classList.remove('is-nudge'); }, 520);
      if (hint) hint.hidden = false;
      ga('th_pdp_knob_tap');
      return;
    }
    if (pos >= max * 0.7) { submitAdd('slide'); return; }
    ga('th_pdp_slide_abandon', { progress: Math.round(pos / max * 100) });
    setPos(0);
  }
  slider.addEventListener('mousedown', down);
  window.addEventListener('mousemove', move);
  window.addEventListener('mouseup', up);
  slider.addEventListener('touchstart', down, { passive: true });
  slider.addEventListener('touchmove', move, { passive: false });
  slider.addEventListener('touchend', up);
  slider.addEventListener('touchcancel', up);
  slider.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); submitAdd('tap'); }
  });
  window.addEventListener('resize', function () { bounds(); setPos(busy ? max : 0); });
  bounds(); setPos(0);
})();
